/* eslint-disable */
/* eslint-disable eslint-comments/no-unused-disable */
/* 
* The file is automatically generated by Serenity UI.
* 
* ⚠️ WARNING: Any manual changes may be overwritten during the next upgrade
* 
* Found an issue? Submit a task to the ClickUp board:
* https://app.clickup.com/1255586/v/l/6-901510012553-1?pr=90154030902
*/
import * as stylex from '@stylexjs/stylex';
import type { HTMLAttributes } from 'react';
import { type ForwardedRef, createContext, forwardRef } from 'react';
import { type ContextValue, useContextProps } from 'react-aria-components';
import { $ } from '../../tokens.stylex';

interface KbdProps extends Omit<HTMLAttributes<HTMLElement>, 'style' | 'className'> {
  /** Whether to display Kbd with background and black text. (Default: false) */
  isEmphasized?: boolean;
  style?: stylex.StyleXStyles;
}

const KbdContext = createContext<ContextValue<KbdProps, HTMLDivElement>>({});

const Kbd = forwardRef((props: KbdProps, ref: ForwardedRef<HTMLDivElement>) => {
  [props, ref] = useContextProps(props, ref, KbdContext);

  const { style, children, isEmphasized = false, ...coreProps } = props;

  return (
    <kbd ref={ref} {...stylex.props(styles.base, isEmphasized && styles.emphasized, style)} {...coreProps}>
      {children}
    </kbd>
  );
});

const styles = stylex.create({
  base: {
    gap: 8,
    paddingInline: 2,
    alignItems: 'center',
    color: $.textTertiary,
    cursor: 'default',
    display: 'flex',
    flexDirection: 'column',
    flexShrink: 0,
    fontFamily: 'Inter',
    fontSize: 12,
    fontStyle: 'normal',
    fontWeight: 400,
    justifyContent: 'center',
    letterSpacing: -0.4,
    userSelect: 'none',
    height: 20,
    minHeight: 20,
  },
  emphasized: {
    borderRadius: 4,
    backgroundColor: $.opacity08,
    color: $.textPrimary,
    minWidth: 20,
    width: 20,
  },
});

export { Kbd, KbdContext, type KbdProps };
